import { Button } from '@components/Button';
import { FRONTEND_URL } from '@/constants/env';
import { useAuth, useUserData } from '@contexts/Auth';
import { useCard } from '@hooks/useCard';
import { useMerchant } from '@hooks/useMerchant';
import { PageWidget } from '@components/PageWidget';
import { Spinner } from '@components/Spinner';
import { Grid, Items, Item, Label, Value, LinkButton } from '../styled';
import { useMerchantRequirements } from '../hooks/useMerchantRequirements';

function ProfileTab() {
  const { data: merchantData, isLoading: isMerchantLoading } = useMerchant();
  const { data: merchantRequirements } = useMerchantRequirements();
  const { email } = useUserData();
  const { data: cardData, isLoading: isCardLoading } = useCard();
  const { changePassword } = useAuth();

  if (isMerchantLoading || isCardLoading) {
    return (
      <PageWidget>
        <Spinner variant='small' />
      </PageWidget>
    );
  }

  return (
    <PageWidget fullWidth={false}>
      <Grid>
        <Items>
          <Item>
            <Label>Name</Label>
            <Value>{merchantData?.full_name && merchantData.full_name}</Value>
            <Value>{email}</Value>
          </Item>
          <Item>
            <Value>
              <Button onClick={changePassword} variant='text'>
                Change password
              </Button>
            </Value>
            <Value>
              {merchantRequirements?.onboarding_link && (
                <LinkButton
                  href={merchantRequirements.onboarding_link}
                  target='_blank'
                  rel='noreferrer'
                >
                  Update my verification information
                </LinkButton>
              )}
            </Value>
          </Item>
        </Items>
        <Items>
          {cardData && (
            <Item>
              <Label>Unique Link</Label>
              <Value>{`${FRONTEND_URL?.replace('https://', '')}/${
                cardData.slug
              }`}</Value>
            </Item>
          )}
        </Items>
      </Grid>
    </PageWidget>
  );
}

export { ProfileTab };
